// components/Header/styles.js
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  width: 100%;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  margin: 0 auto;
`;

export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  
  a {
    text-decoration: none;
    color: #333;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProfileImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfilePic = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfilePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #495057;
  background-color: #dee2e6;
`;

export const UserName = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const MyPageButton = styled(Link)`
  padding: 6px 12px;
  margin-left: 10px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  background-color: #e9ecef;
  color: #212529;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #dde2e6;
  }
`;

export const LogoutButton = styled.button`
  padding: 6px 12px;
  margin-left: 10px;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e9ecef;
  }
`;